/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type MigrateIssuerRequestBody2 = {
  /**
   * The exact warnings_fingerprint returned by the latest preflight. Required when that preflight reports warnings.
   */
  confirmedWarningsFingerprint?: string | undefined;
  /**
   * The user_session_issuer to migrate away from; soft-deleted on success.
   */
  sourceId: string;
  /**
   * The surviving user_session_issuer.
   */
  targetId: string;
};

/** @internal */
export type MigrateIssuerRequestBody2$Outbound = {
  confirmed_warnings_fingerprint?: string | undefined;
  source_id: string;
  target_id: string;
};

/** @internal */
export const MigrateIssuerRequestBody2$outboundSchema: z.ZodMiniType<
  MigrateIssuerRequestBody2$Outbound,
  MigrateIssuerRequestBody2
> = z.pipe(
  z.object({
    confirmedWarningsFingerprint: z.optional(z.string()),
    sourceId: z.string(),
    targetId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      confirmedWarningsFingerprint: "confirmed_warnings_fingerprint",
      sourceId: "source_id",
      targetId: "target_id",
    });
  }),
);

export function migrateIssuerRequestBody2ToJSON(
  migrateIssuerRequestBody2: MigrateIssuerRequestBody2,
): string {
  return JSON.stringify(
    MigrateIssuerRequestBody2$outboundSchema.parse(migrateIssuerRequestBody2),
  );
}
